import React from "react";
import { IWorkspaceProjects, IWorkspaceTeams } from "app/types";
import {
  ITicketTypes
} from "../../../TeamSettings/container/Projects/container/WorkItems/types";
import { ITicketFormData } from "../../containers/Tickets/types";
import TicketContextFields from "../../../Ticket/components/TicketDetailsComponent/TicketContextFields";

interface Props {
  form: ITicketFormData;
  ticketTypes: ITicketTypes[];
  projectId: string;
  createTicketForHome: boolean;
  selectedTeam: IWorkspaceTeams;
  selectedProject: IWorkspaceProjects;
  isAddEpicModal?: boolean;
}

const ContextFields: React.FC<Props> = ({
  form,
  ticketTypes,
  projectId,
  createTicketForHome,
  selectedTeam,
  selectedProject,
  isAddEpicModal = false,
}) => {


  /* ------------------------------ UI -------------------------------- */

  return (
    <TicketContextFields
      createTicketForHome={createTicketForHome}
      form={form}
      ticketTypes={ticketTypes}
      projectId={projectId}
      selectedTeam={selectedTeam}
      selectedProject={selectedProject}
      isAddEpicModal={isAddEpicModal}
    />
  );
};

export default ContextFields;
